import { z } from "zod";

/**
 * Base schema for quiz response creation.
 */
export const quizResponseCreateSchema = z.object({
  quiz: z.number(),
  user: z.number(),
  status: z.enum(["in_progress", "completed"]),
});

/**
 * Schema for quiz answer submission.
 */
export const quizAnswerSchema = z.object({
  quiz_response: z.number(),
  question: z.number(),
  selected_quiz_choices: z.array(z.number()).optional(),
  answer_text: z.string().optional(),
});

export type QuizResponseCreateData = z.infer<typeof quizResponseCreateSchema>;
export type QuizAnswerData = z.infer<typeof quizAnswerSchema>;

